import { ButtonSize, IconSize } from "../../classes/enums/ButtonEnum";
import IconsEnum from "../../classes/enums/IconsEnum";
import IconButton from "../iconButton/IconButton";
import "./AddNew.css";
import useTranslation from "../../hooks/i18n/useTranslation";

const AddNew = ({ elementTitle, onClick = () => {} }) => {
  const { t } = useTranslation();
  return (
    <div className="add-new-container" style={{ cursor: onClick ? "pointer" : "default" }} onClick={onClick}>
      <IconButton
        icon={IconsEnum.ADD}
        iconSize={IconSize.MEDIUM}
        size={ButtonSize.MEDIUM}
        isCircle={true}
        isLightBlue={true}
        noBgColor={true}
        disabled={false}
        title={t("50")}
      />
      <div className="App-text-large add-new-label">
        {t("190")} {elementTitle}
      </div>
    </div>
  );
};

export default AddNew;
